import React, {useState} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {useSelector} from 'react-redux';
import ReorderWidgetsDialog from 'components/GenericReorderDialog';
import PageBreadcrumbs from 'components/Breadcrumbs';
import 'components/css/multiGrid.css';
import styled from 'styled-components';
import {Dropdown, theme} from '@partssourceinc/react-ui-core';

const StyledDropdown = styled(Dropdown)`
    width: 400px;
    @media screen and (max-width: ${theme.screenSMMax}) {
        width: 250px;
    }
    @media screen and (max-width: ${theme.screenXsMax}) {
        width: 200px;
    }
`;

const HeaderWrapper = styled.div`
    display: flex;
    min-height: 150px;
    background: white;
    margin: 0px -20px;
    padding: 0px 20px;
    flex-direction: column;
    position: relative;
    @media screen and (min-width: ${theme.screenXLMin}) {
        margin: 0 -50px;
        padding: 0 50px;
    }
    @media screen and (max-width: ${theme.screenLGMax}) {
        margin: 0 -50px;
        padding: 0 50px;
    }
    @media screen and (max-width: ${theme.screenMDMax}) {
        margin: 0 -20px;
        padding: 0 20px;
    }
    @media screen and (max-width: ${theme.screenSMMax}) {
        margin: 0 -20px;
        padding: 0 20px;
    }
    @media screen and (max-width: ${theme.screenXsMax}) {
        margin: 0 -20px;
        padding: 0 20px;
    }
    @media screen and (max-width: 320px) {
        margin: 0 -20px;
        padding: 0 20px;
    }
`

const DropdownContainer = styled.div`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    @media screen and (max-width: ${theme.screenSMMax}) {
        position: static;
        transform: none;
        margin: 20px auto;
    }
`;

const ReorderContainer = styled.div`
    position: absolute;
    right: 20px;
    @media screen and (max-width: ${theme.screenSMMax}) {
        position: static;
        text-align: right;
        margin-top: 10px;
    }
`;

const ReportingPortalHeaderPowerBi = (props) => {
    const {updateWidgetsOrder, facilities, selectedCompanyId, onFacilityChange} = props;
    const portal = useSelector(state => state.user.userDashboardSettings.data.portal);
    const [widgets, setWidgets] = useState(portal.widgets);
    const [showReorderDialog, setShowReorderDialog] = useState(false);
    const onConfirmReorder = (items) => {
        setWidgets(items);
        updateWidgetsOrder(_.cloneDeep(items));
        setShowReorderDialog(false);
    }

    const onCancelReorder = () => {
        setShowReorderDialog(false);
    }

    return (
        <HeaderWrapper style={{marginTop: '20px', marginBottom: '20px'}}>
            <div style= {{display: 'flex', alignItems: 'center'}}>
                <PageBreadcrumbs style={{marginTop: '0px'}} />
                {facilities?.length > 1 && (
                    <DropdownContainer>
                        <StyledDropdown
                            options={facilities}
                            valueField="id"
                            textField="name"
                            selectedValue={selectedCompanyId}
                            onChange={e => onFacilityChange(e.target.value)}
                            placeholder="Company"
                            label="Company"
                            suppressBlankOption={true}
                        />
                    </DropdownContainer>
                )}
                {updateWidgetsOrder && widgets.length > 1 && (
                    <ReorderContainer>
                        <a 
                            className="text-uppercase font-weight-bold text-secondary" 
                            onClick={() => { 
                                setShowReorderDialog(true) 
                            }} 
                            role="button">Reorder</a>
                    </ReorderContainer>
                )}
            </div> 
            {
                showReorderDialog && <ReorderWidgetsDialog items={widgets} onConfirm={onConfirmReorder} onCancel={onCancelReorder} />    
            }
        </HeaderWrapper>
    );
}

ReportingPortalHeaderPowerBi.propTypes = {
    updateWidgetsOrder: PropTypes.func,
    facilities: PropTypes.array,
    selectedCompanyId: PropTypes.string,
    onFacilityChange: PropTypes.func
};

export default ReportingPortalHeaderPowerBi;
